import './ExplanationButton.css';

import * as React from 'react';

export interface Props {
    onClick: () => void;
    titleAttr?: string;
}

const ExplanationButtonArrow: React.SFC<Props> = ({ titleAttr, onClick }) => {
    let titleText = titleAttr ? `View the explanation video for ${titleAttr}` : "View the explanation";
    titleText += ', opens in a modal window';
    return (
        <button title={titleText} className="practice-explanation-button" onClick={onClick}>
            <img
              className="explanation-button-image"
              src={`/assets/images/icons/v2/ico-explanation.svg`}
              width="20"
              height="20"
              alt=""
            />
        </button>
    );
};

ExplanationButtonArrow.defaultProps = { };
ExplanationButtonArrow.displayName = 'AnalysisButton';

export default ExplanationButtonArrow;
